export default __webpack_public_path__ + "static/media/helping-our-own.da61419c.png";